// APIs & Services

// Links
export const LINK_RIMAC = '#';
export const LINK_RIMAC_POLITICAS_DE_PRIVACIDAD =
  'https://rimac.com/politica-privacidad';

export const LINK_BBVA = 'https://www.bbva.pe/';
export const LINK_HOME_UTM = `${process.env.REACT_APP_PUBLIC_URL}?rfid=publica:formulario-siniestros-proteccion-bbva:resultado:button`;
export const LINK_PRODUCTOS_BBVA =
  'https://www.bbva.pe/personas/productos/seguros/bienes/proteccion-de-tarjetas?mcid=publica:referral:08_2023_siniestros-proteccion-bbva_per-conversion:clientes:volver-a-bbva:boton';
export const LINK_PRODUCTOS_BBVA_TYPE = (type) =>
  `https://www.bbva.pe/personas/productos/seguros/bienes/proteccion-de-tarjetas?mcid=publica:referral:08_2023_siniestros-proteccion-bbva_per-conversion:clientes:volver-a-bbva-${type}:boton`;
export const LINK_BBVA_BANCA =
  'https://www.bbva.pe/?cid=sem:br:ggl:pe-ao_vd_open_brand_digitalizacion-gen-general:Banca_Internet_BBVA-online_performance:::bbva%20banca%20por%20internet:e:::text:&gclid=Cj0KCQjwu7OIBhCsARIsALxCUaMeiwFuldcZWUxbMl-ISUdxZrBuErwR2XaFnQqQGi77p0s-UOZ4yekaAiITEALw_wcB';
export const LINK_BBVA_BANCA_MOBILE =
  'https://www.bbva.pe/personas/servicios-digitales/banca-movil.html';
export const LINK_BBVA_COBER_INFO =
  'https://www.bbva.pe/content/dam/public-web/peru/documents/personas/seguros/Cobertura-de-MA-e-ITP.png';
export const LINK_BBVA_SEGURO_TARJETAS =
  'https://www.bbva.pe/personas/productos/seguros/bienes/proteccion-de-tarjetas.html';

// Default values
export const DEFAULT_RIMAC_COPYRIGHT = '© 2023 RIMAC Seguros y Reaseguros.';
export const PAGINAS_BY_STEP = {
  HOME: {
    step: 0,
    uri: '/',
    descripcion: 'Home',
    seccionEditar: 'Contacto'
  },
  DETALLE_SINIESTRO: {
    step: 1,
    uri: '/detalle-siniestro',
    descripcion: 'Detalle Siniestro',
    seccionEditar: ''
  },
  OTRO_SEGURO: {
    step: 2,
    uri: '/otros-seguros',
    descripcion: 'Otros Seguros',
    seccionEditar: 'Home'
  },
  DESCRIPCION_OTRO_SINIESTRO: {
    step: 3,
    uri: '/otro-caso',
    descripcion: 'Descripción mi siniestro es otro',
    seccionEditar: 'Detalle siniestro'
  },
  ANTES_EMPEZAR: {
    step: 4,
    uri: '/antes-de-comenzar',
    descripcion: 'Antes de comenzar',
    seccionEditar: ''
  },
  DOCUMENTOS_REQUERIDOS: {
    step: 5,
    uri: '/documentos-requeridos',
    descripcion: 'Documentos requeridos',
    seccionEditar: 'Documentos'
  },
  MONTOS_ROBADOS: {
    step: 6,
    uri: '/montos-robados',
    descripcion: 'Montos robados',
    seccionEditar: 'Monto'
  },
  INFO_REEMBOLSO: {
    step: 7,
    uri: '/info-reembolso',
    descripcion: 'Info reembolso',
    seccionEditar: 'Cuenta bancaria'
  },
  THANKYOU: {
    step: 9,
    uri: '/gracias',
    descripcion: 'Gracias',
    seccionEditar: ''
  },
  NEW_THANKYOU: {
    step: 9,
    uri: '/new-gracias',
    descripcion: 'Nuevo Gracias',
    seccionEditar: ''
  }
};
